var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.914 14.315c-2.306 2.308-4.986.078-5.1-.02a.375.375 0 00-.488.57c.022.019 1.475 1.237 3.268 1.237.91 0 1.907-.313 2.85-1.257a.375.375 0 00-.53-.53",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.296 11.646h-.422l-.012.363a6.514 6.514 0 01-6.536 6.336 6.512 6.512 0 01-6.537-6.35l-.01-.341-.34-.023a.998.998 0 01-.94-.985c0-.552.45-1.001 1.002-1.001.054 0 .12.018.26.059l.329.09.121-.319a6.579 6.579 0 016.115-4.225c.121 0 .24.021.36.028-.089.32-.485 1.367-2.04 2.17a.375.375 0 00.343.666c1.4-.722 2.013-1.652 2.275-2.243.11.124.215.283.264.473.076.293.002.62-.217.97a.374.374 0 10.636.399c.333-.532.436-1.056.306-1.557a1.845 1.845 0 00-.358-.693c2.049.516 3.786 1.997 4.552 4.03l.13.343.345-.122c.1-.034.214-.07.326-.07a1.003 1.003 0 01.048 2.002m-.048-2.751c-.08 0-.155.007-.225.018C17.877 6.26 15.228 4.5 12.326 4.5 9.43 4.5 6.78 6.256 5.634 8.904a1.065 1.065 0 00-.133-.01c-.965 0-1.751.787-1.751 1.752 0 .797.55 1.48 1.305 1.678a7.256 7.256 0 007.27 6.771 7.259 7.259 0 007.268-6.732A1.754 1.754 0 0021 10.646c0-.965-.786-1.751-1.752-1.751",
    strokeWidth: 0.3
  })))));
}
export default SvgChildCare;